export enum ICommercialTabs {
  addVoyage = "1",
  voyageTable = "2",
}
